<template>
  <div class="terms">
    <div class="header mt-2">
      <div />
      <div class="h1 flex justify-content-center">
        Terms of Use
      </div>
      <div class="flex justify-content-end">
        <AuButton
          center
          width="100px"
          @click="openDoc"
        >
          Download
        </AuButton>
      </div>
    </div>
    <div class="h5 mt-5 ms-4 me-4">
      <p><strong>Last Updated: 2.02.2026</strong></p>

      <p>
        These Terms of Use (hereinafter -- the "Terms") set out the terms
        between you and us, subject to which you may enjoy access and use the
        RWA.capital Platform, including our website(s), mobile application(s),
        as well as any related pages, features, content and services that we may
        make available from time to time (together -- the "Platform").
      </p>

      <p>
        By accessing or using the Platform you confirm that you are aware of the
        provisions set forth within these Terms, and agree to be bound by the
        respective provisions, together with our Privacy Policy and Cookie
        Notice (together -- the "Platform Policies"). In the event you do not
        accept these Terms or the Platform Policies, you must not access or use
        the Platform.
      </p>

      <p>
        The Platform is operated by [Legal Entity Name] ("we", "us" or the
        "Company"), a company incorporated in the Dubai International Financial
        Centre (DIFC) with registered address at [Address].
      </p>

      <p>
        We enjoy the right to modify or amend any of the provisions of these
        Terms, the Platform, or any content on the Platform from time to time
        (including for security, legal or regulatory reasons, also including
        upon demands from the Dubai Financial Services Authority/DFSA, or to
        reflect updates or changes to the services or functionality of the
        Platform). You are expected to check the Platform on a regular basis.
        Any respective changes shall take effect immediately as soon as posted
        officially on the Platform. By using the Platform after changes are
        posted you accept those respective changes. It is our strong
        recommendation that you check the effective version of these Terms
        regularly.
      </p>

      <h3 class="mt-4">
        Access to Investment Functionality
      </h3>
      <p>
        Any user may browse any public sections of the Platform (e.g., project
        descriptions, general materials) with no prior registration.
      </p>
      <p>
        To access restricted sections (e.g., expression of interest, onboarding,
        viewing detailed materials), you may register an account.
      </p>
      <p><strong>Registration shall not constitute:</strong></p>
      <ul>
        <li>automatic approval as an investor;</li>
        <li>the possibility of making any investment(s);</li>
        <li>the creation of any legally binding relationship.</li>
      </ul>

      <h3 class="mt-4">
        Investment Phase – Subject to Licensing
      </h3>
      <p>
        The actual possibility of investing, including:
      </p>
      <ul>
        <li>wallet top-up;</li>
        <li>investment confirmation;</li>
        <li>reservation of funds,</li>
        <li>issuance of shares/units in an SPV,</li>
      </ul>
      <p>
        will be available <strong>only after obtaining a DFSA license</strong> and <strong>upon
          special acceptance of the Investor Terms and Conditions</strong>. Until that
        time, <strong>any actions shall be considered of informational nature only</strong>.
      </p>

      <p>
        In the event you choose to register as an investor and/or access
        restricted sections of the Platform, you must comply with our Investor Terms and Conditions and with all the provisions of any other documents we will provide during the registration and onboarding (including risk disclosures, fees, and SPV papers). These Terms shall apply in addition to the said documents. In case of any conflict, the Investor Terms and Conditions shall prevail regarding any investment-related matters.
      </p>

      <h3 class="mt-4">
        Prohibited Use
      </h3>
      <p>
        You may use the Platform for lawful purposes only and in accordance with these Terms. You must not use the Platform:
      </p>
      <ul>
        <li>in any way that may be found in breach of any applicable local, national or international laws or regulations (including the DFSA rules, anti-money laundering, counter-terrorist financing and sanctions laws);</li>
        <li>in any way that is unlawful or fraudulent, or may have any unlawful or fraudulent purpose or effect;</li>
        <li>for any purpose that may imply harming or attempting to harm minors in any way;</li>
        <li>to send/knowingly receive/download any data that does not comply with the Content Standards set out below;</li>
        <li>to transmit, or help transmit any unsolicited or unauthorized advertising or promotional material or any other form of similar solicitation (spam), including any referral or affiliate promotion carried out without our prior written approval;</li>
        <li>to transmit any harmful data or codes (viruses, Trojan horses, spyware, etc.);</li>
        <li>in any manner that could, or could reasonably be expected to, damage, disable, overburden or impair any of our servers, networks or systems, or any network connected to any of our servers;</li>
        <li>in any manner that would, or could reasonably be expected to, interfere with any other party's use of the Platform or which is, or is likely to be, in contravention of any applicable laws or any party's rights or legal entitlements under any applicable laws;</li>
        <li>while employing any robot, spider, screen scraper, data aggregation tool, crawler or any other automatic device ("Automated Process") to monitor, copy or extract any pages/data on the Platform, or any information/content contained within or accessible through the Platform, without our prior written permission;</li>
        <li>using any Automated Process to aggregate or combine information, content or data contained within or accessible through the Platform with any information, content or data accessible via or sourced from any third party, or to interfere or attempt to interfere with the proper performance of the Platform or any transaction or process being conducted on or through the Platform;</li>
        <li>to post, upload, transmit, distribute, store, create or otherwise publish or make available through the Platform any content that is false, misleading, erroneous, fraudulent or is otherwise likely to cause confusion to users of the Platform, or content which is unlawful, libelous, defamatory, offensive in any way, obscene, pornographic, indecent, lewd, suggestive, harassing, threatening, invasive of privacy or publicity rights, abusive, inflammatory, hateful or otherwise objectionable;</li>
        <li>to take any action that imposes an unreasonable or disproportionately large load on the infrastructure of, or bandwidth connecting to, the Platform;</li>
        <li>to attempt to gain unauthorized access to the Platform, the respective servers or database connected to the Platform;</li>
        <li>to attempt to carry out any DoS/DDoS attack;</li>
        <li>to reverse engineer, reverse assemble, decompile, disassemble, or otherwise attempt to discover the source code, algorithms, models or processes in respect of the software underlying the Platform;</li>
        <li>to copy, reproduce, alter, modify, create derivative works from, sell, resell, or publicly display any part of any content from the Platform without our prior written permission.</li>
      </ul>

      <p>
        If you use the Platform in violation of these provisions, we are within
        our full right (among other things) to suspend or terminate your
        respective access to the Platform and/or report relevant matters to
        appropriate authorities.
      </p>

      <p>
        Where we suspect any illegal or fraudulent activity, a breach of
        sanctions, or a breach of any AML/CTF laws, we may take respective
        actions with no prior notice as may be required or permitted by law.
      </p>

      <h3 class="mt-4">
        Content Standards
      </h3>
      <p>
        These content standards shall apply to all materials that you contribute
        to the Platform ("Contributions"). You must comply with both the
        inspiration and the letter of the following standards.
      </p>

      <p><strong>Contributions must:</strong></p>
      <ul>
        <li>be accurate (where they state facts);</li>
        <li>be genuinely held (where they state opinions); and</li>
        <li>comply with duly applicable law in any country from which they are posted.</li>
      </ul>

      <p><strong>Contributions must not:</strong></p>
      <ul>
        <li>contain any material which is defamatory of any person or damaging in any way;</li>
        <li>contain any material which is obscene, offensive, hateful or inflammatory in any way;</li>
        <li>promote any sex-related content, violence or discrimination;</li>
        <li>infringe any copyright, database right or trade mark of any other person;</li>
        <li>be misleading or likely to deceive any person;</li>
        <li>be made in breach of any legal duty owed to a third party;</li>
        <li>promote any illegal activity;</li>
        <li>be threatening, abuse or invade another's privacy, or cause annoyance, inconvenience or needless anxiety;</li>
        <li>be misleading concerning anybody's personality/affiliation or produce any impression that they emanate from us, provided this is not the case.</li>
      </ul>

      <h3 class="mt-4">
        Disclaimer and Risk Warning
      </h3>
      <p>
        The Platform is a marketplace and an infrastructure that offers access
        to information and (subject to our Investor Terms and Conditions)
        investment in real estate opportunities structured through special
        purpose vehicles ("SPVs") and other respective transaction arrangements.
        Investments are typically made by subscribing for shares, units or other
        interests in the respective SPV, and not through obtaining direct legal
        title to the underlying property.
      </p>

      <p>
        You herewith acknowledge and agree that no content published on the
        Platform shall constitute a recommendation that any particular
        investment, portfolio of investments, transaction, or investment
        strategy is suitable or advisable for you or any other specific person.
        You further understand that any content and material available on the
        Platform are for informational purposes only and are not intended to
        address your particular requirements. Prior to making any investment
        decision, you should seek independent advice from suitably qualified
        advisers (including financial, legal and tax advisers).
      </p>

      <p>
        The value of investments and the income derived from them can fluctuate
        or even be not available at all, and you may not necessarily recover the
        amount you invested. Past performance is not necessarily a guide to
        future performance.
      </p>

      <p>
        Investments in private SPVs are generally illiquid. Any secondary
        market, resale facility or "exit window" (if offered) may be limited in
        time, volume, participant eligibility and pricing mechanism. We do not
        guarantee that any buyer will be available, that any exit window will
        occur, or that you will be able to exit at a particular price or at all.
      </p>

      <p>
        We do not hold, control, nor take possession of your investment funds.
        Where investments are made through the Platform, payments are typically
        processed via third-party payment service providers and/or placed into
        an escrow account maintained with an independent escrow agent or
        regulated financial institution (as applicable). The escrow arrangements
        and the conditions for release of funds are governed by the applicable
        transaction documentation. You herewith acknowledge that any delays,
        failures or disputes involving any third-party payment providers, escrow
        agents or banks may affect the timing or availability of transactions.
      </p>

      <p>
        You acknowledge and agree that any details (including prices,
        descriptions, projected returns and other financial or property-related
        data) made available on the Platform may be compiled from third party
        sources and, therefore, may not be complete, current or accurate. Any
        returns/forecasts advertised or illustrated on the Platform are
        indicative only and shall not be guaranteed.
      </p>

      <p>
        Nothing on the Platform constitutes an offer or solicitation to sell, or
        distribution of, investments and related services to anyone in any
        jurisdiction where such offer, solicitation or distribution would be
        unlawful. We may restrict access to the Platform or certain parts of it
        in order to comply with the respective DFSA requirements, sanctions and
        other legal or regulatory obligations.
      </p>

      <h3 class="mt-4">
        Disclaimers of Warranties
      </h3>
      <p>
        The Platform is provided on an "as is" and "as available" basis, without
        any express or implied warranties of any kind as long as it is lawful.
        We cannot and do not warrant that the Platform is the right tool for you
        to arrive at a particular result in view of your expectations. Although
        we make reasonable efforts to ensure that the Platform and any services
        offered on it are available consistently, we do not warrant that the
        Platform (or any part of it) will be available, uninterrupted or
        error-free, that defects will be corrected, or that the Platform will be
        free of viruses or any other harmful components.
      </p>

      <p>
        The Operator of the Platform does not warrant that the Platform and its
        respective content will be available consistently at any time, in any
        country or region.
      </p>

      <p>
        You are solely responsible for obtaining the Internet access as well as
        for any equipment, devices and safeguarding software (including
        antivirus solutions). And data transmitted via the Platform may pass
        over public telecommunications networks, and therefore, may be
        intercepted, delayed, incorrectly delivered or not delivered at all, for
        which we may not be held liable.
      </p>

      <p>
        This disclaimer shall not apply to obligations arising from applicable
        DIFC law and DFSA regulatory requirements (e.g., liability for providing
        false information).
      </p>

      <h3 class="mt-4">
        Means of Access
      </h3>
      <p>
        The Platform is generally intended to be viewed by a conventional web
        browser and/or accessed via our mobile application on a compatible
        device. The Platform may not appear accurately or function correctly
        through any other access methods.
      </p>

      <p>
        You must not access the Platform through any devices, scripts or
        services that are designed to provide high-speed, automated, repeated
        access.
      </p>

      <p>
        Certain parts of the Platform are protected by passwords, multi-factor
        authentication and/or require a login. You must not obtain or attempt to
        obtain unauthorized access to such parts of the Platform.
      </p>

      <h3 class="mt-4">
        Eligibility and Registration
      </h3>
      <p>
        Registration is completed via the Platform by filling out a specific
        registration form. The User shall independently submit the information
        requested by the Platform and create an Account password in accordance
        with the respective requirements.
      </p>

      <p>
        To access the Platform, you must be at least eighteen (18) years old
        (according to the Gregorian calendar) and enjoy full legal capacity.
      </p>

      <p>
        Access to any investment functionality is subject to
        registration/onboarding. We are within our full right to limit
        registration and access even to persons who meet the eligibility
        criteria and the duly applicable DFSA client categorization requirements
        (e.g., Retail Clients and Professional Clients), as well as any other
        internal requirements (Qualified Investors, if applicable).
      </p>

      <p>
        While going through registration, you will be required to submit basic
        details and create your credentials. For compliance purposes, we may
        request certain official documents and information for identification,
        client classification, and AML/CTF/sanctions screening. We may use
        third-party service providers (including SumSub or similar) and request
        proof of address, source of funds/source of wealth, and other relevant
        information.
      </p>

      <p>
        All applications to register shall remain subject to an approval process
        and may be accepted or rejected by us in our sole discretion (including
        where required by law or in view of applicable regulations). All the
        details you submit must be accurate, relevant and complete.
      </p>

      <p>
        We may impose minimum investment amounts, concentration limits,
        cooling-off requirements and other restrictions in accordance with
        applicable law, DFSA requirements and our internal policies.
      </p>

      <h3 class="mt-4">
        Your Login Details
      </h3>
      <p>
        You are responsible for any activity related to your account on the
        Platform. Your credentials are non-transferable. You are obliged to keep
        them confidential, as well as you must respectively notify us as soon as
        you become aware of any loss, theft, or unauthorized use of the said
        data.
      </p>

      <p>
        Contact: <a href="mailto:contact@rwa.capital">contact@rwa.capital</a>
      </p>

      <p>
        In case you grant access to any employee/contractor/agent, you shall be
        held liable for their actions. We reserve the right to decline
        instructions if we suspect unauthorized access, fraud, or any other
        breach.
      </p>

      <h3 class="mt-4">
        Links to and from other sites
      </h3>
      <p>
        Hyperlinks to any external websites are offered for your convenience. We
        neither monitor nor assume any responsibility for the
        content/performance of such websites.
      </p>

      <p>
        The Platform must not be framed on any other site, nor may you create a
        link to any part of the Platform without our prior written consent. We
        reserve the right to withdraw any linking permission without notice.
      </p>

      <p>
        We assume no responsibility for the use of, or inability to use, any
        third party software or other materials available on the Platform.
      </p>

      <h3 class="mt-4">
        Limitation of Liability and Indemnity
      </h3>
      <p>
        You use the Platform at your own risk. To the extent duly permitted by
        respectively applicable law, neither we nor any of our affiliates,
        agents, officers, employees, suppliers or licensors shall be held liable
        to you or anyone else for any direct or indirect damages, including loss
        of profits, data, business process failures, decisions that you may make
        based on the information available through the Platform, nor for any
        other consequences of using or being unable to use the Platform.
      </p>

      <p>
        Nothing herein limits liability that cannot be excluded by law,
        including liability for death or personal injury caused through our
        negligence, as well as for fraud or fraudulent misrepresentation.
      </p>

      <p>
        Our aggregate liability to you in connection with the provisions of
        these Terms and Platform Policies (unless prohibited by applicable law)
        shall not exceed AED 10,000.
      </p>

      <p><strong>Indemnity</strong></p>
      <p>
        You herewith agree to indemnify us and our affiliates for reasonable
        losses and expenses (including legal fees) incurred as a result of: (i)
        your material breach of these Terms; (ii) your willful misconduct,
        fraud, or illegal acts; (iii) your violation of third-party rights (IP,
        privacy, etc.) -- to the extent that such losses are caused by you and
        are not due to our gross negligence, willful misconduct, or fraud. We
        will make every endeavor to notify you of any claim for which
        indemnification is sought and, where appropriate, will offer an
        opportunity to be involved in the defense, subject to applicable law and
        regulatory requirements.
      </p>

      <h3 class="mt-4">
        Availability of the Platform
      </h3>
      <p>
        We reserve the right to limit the availability of the Platform to any
        person, geographic area or jurisdiction we may choose, and/or to
        terminate any access to and use of the Platform, at any time and in our
        sole discretion, as well as for commercial, security, technical,
        maintenance, legal or regulatory reasons, or due to any breach any of
        the provisions of these Terms.
      </p>

      <h3 class="mt-4">
        Intellectual Property
      </h3>
      <p>
        We own all the rights to the Platform and its components (including all
        the respective content, databases, software, trademarks, etc.), unless
        otherwise stated. You shall retain the rights to the content you upload,
        yet you grant us a worldwide, perpetual, royalty-free license (with the
        right to any sublicense) to use, store, reproduce, distribute, and
        transfer such content for the purposes of operating and improving the
        performance of the Platform, as well as complying with legal and
        regulatory requirements.
      </p>

      <p>
        We enjoy our full right to disclose your identity to any third parties
        in the event any reasonable claim is made regarding rights infringement,
        as well as we reserve the right to remove any materials that you may
        post.
      </p>

      <h3 class="mt-4">
        Copyrights and trademarks
      </h3>
      <p>
        The Platform and its content are protected by duly applicable laws.
      </p>

      <p>
        Except where may be necessary for and incidental to personally viewing
        the Platform or using the Platform as intended, no part of the Platform
        may be reproduced, stored, modified, adapted, uploaded to any third
        party resources, framed, displayed in public, or transmitted in any form
        or by any process whatsoever, without our specific prior written
        consent.
      </p>

      <h3 class="mt-4">
        Confidentiality
      </h3>
      <p>
        You undertake to maintain the confidentiality of any Confidential
        Information obtained through the Platform and to use it solely for the
        purposes of evaluating or executing transactions via the Platform.
        "Confidential Information" shall imply any information about us,
        investors, SPVs, counterparties, providers, and other users disclosed
        through the Platform, except in cases where disclosure is required by
        law or a regulator.
      </p>

      <h3 class="mt-4">
        Suspension and Termination
      </h3>
      <p>
        We will determine, in our sole discretion, whether there has been a
        breach of any of the provisions of these Terms.
      </p>

      <p>
        We may suspend or terminate your access and/or your account for any
        reason or no reason, with or without notice. All disclaimers,
        limitations of liability, and provisions which by their nature are
        intended to survive termination shall continue in full force and effect.
      </p>

      <h3 class="mt-4">
        General terms
      </h3>
      <p>
        <strong>No waiver.</strong> No full or partial waiver shall restrict us from
        exercising that right or remedy, or any other right or remedy, in the
        future.
      </p>

      <p>
        <strong>Severability.</strong> Should any provision of these Terms be deemed invalid,
        unlawful or unenforceable, to any extent, the remaining provisions will
        continue to be valid, as far as permitted by the DIFC law.
      </p>

      <p>
        <strong>No partnership.</strong> Nothing in these Terms is intended to or will be
        used to establish any partnership or any joint venture.
      </p>

      <p>
        <strong>Tax.</strong> You should take your own tax advice.
      </p>

      <p>
        <strong>Notices.</strong> Any notice or other communication given by either party to
        the other in connection with these Terms shall be in writing and
        delivered by hand or sent by pre-paid first class post (or an
        equivalent) to that party's registered address (if a company) or its
        principal place of business or residential address (if an individual),
        or sent by email to the respective address notified to the other party.
        Our email address for the service of notices is <a href="mailto:contact@rwa.capital">contact@rwa.capital</a>
      </p>

      <p>
        A notice shall be deemed to have been received: if delivered by hand --
        at the time of signing the delivery confirmation or when left at the
        respective address; by email -- at 9:00 AM on the next business day
        following sending; by mail (or another delivery service) -- on the
        second business day following mailing.
      </p>

      <p>
        <strong>Language.</strong> All correspondence and communication between you and us
        shall be carried out in the English language.
      </p>

      <p>
        <strong>Governing law and jurisdiction.</strong> Any dispute or claim arising out of
        or in connection with the Platform or these Terms shall be governed by
        the DIFC law and shall be subject to exclusive jurisdiction of the DIFC
        Courts.
      </p>

      <p>
        <strong>Entire agreement.</strong> These Terms, together with any document expressly
        referred to herewith, shall constitute the whole agreement between the
        parties, and shall supersede all previous agreements relating to this
        subject matter.
      </p>

      <h3 class="mt-4">
        Changes to Terms
      </h3>
      <p>
        We may revise the provisions of these Terms at any time by displaying
        the revised version on the Platform. You are expected to check the
        effective version of these Terms regularly. Certain provisions may also
        be expanded through notifications displayed on the Platform.
      </p>

      <h3 class="mt-4">
        Contact Us
      </h3>
      <p>
        In the event you have any questions about these Terms, or wish to
        contact us for any reason, please contact us at <a href="mailto:contact@rwa.capital">contact@rwa.capital</a>
      </p>

      <p>
        Any disputes and differences that may arise between the Parties shall be
        settled through negotiations. The Parties undertake to comply with the
        pre-trial (complaint) dispute resolution procedure.
      </p>
    </div>
  </div>
</template>

<script setup>
import AuButton from "@/components/extended/AuButton.vue";
import { checkAccess, scope } from "@/help/accessData";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const openDoc = () => {
  window.open("/docs/Term_of_use_rwa.pdf", "_blank");
};
onMounted(() => {
  if (checkAccess(scope.notRwa)) {
    router.push({ name: "page not found" });
  }
});
</script>

<style scoped lang="scss">
.terms {
  background-color: var(--main-color);
  padding-bottom: 10px;

  .header {
    display: grid;
    grid-template-columns: 33% auto 33%;
    padding-right: 20px;
  }
}

a {
  color: var(--color-green);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>